export default __webpack_public_path__ + "static/media/ellenMonteiro.1def6535.jpg";